import { memo } from 'react';

import NoteBody from '@/components/NoteBody';
import type { AffectUser } from '@/types/affectUser';
import type { Note } from '@/types/note';
import DualTime from '@/ui/components/DualTime';
import formatStaffName from '@/utils/formatStaffName';

interface Props {
  note?: (Omit<Note, 'body'> & { body?: unknown }) | null;
  createdBy?: AffectUser | null;
  createdAt?: string | null;
}

const ExpectationDetailsAccordion = ({ note, createdBy, createdAt }: Props) => {
  const normalizedBody = typeof note?.body === 'string' ? note.body.trim() : '';
  const normalizedCreatedAt = createdAt ?? note?.created_at ?? null;
  const hasBody = normalizedBody.length > 0;
  const normalizedNote: Note = {
    ...(note ?? {
      id: null,
      object_id: '',
      note_type: null,
      created_at: '',
      body: ''
    }),
    body: normalizedBody,
    author: createdBy ?? note?.author ?? null,
    created_at: normalizedCreatedAt ?? ''
  };

  const hasMetadata = normalizedCreatedAt || normalizedNote.author;
  const hasContent = hasBody || hasMetadata;

  if (!hasContent) {
    return null;
  }

  return (
    <div className="mt-2 text-sm text-uniform-gray-700 dark:text-uniform-gray-300">
      {hasBody && <NoteBody note={normalizedNote} />}

      {hasMetadata && (
        <p className="text-xs text-uniform-gray-500 mt-1">
          {normalizedNote.note_type && (
            <span className="mr-1">{normalizedNote.note_type.title},</span>
          )}
          {normalizedCreatedAt && (
            <>
              Created <DualTime dateTime={new Date(normalizedCreatedAt)} />
            </>
          )}
          {normalizedNote.author && (
            <span>
              {normalizedCreatedAt && ' '}
              by {formatStaffName({ staff: normalizedNote.author })}
            </span>
          )}
        </p>
      )}
    </div>
  );
};

export default memo(ExpectationDetailsAccordion);
